import { FC } from 'react';

import {
  GiveawayDetailed,
  GiveawayDetailedArchive,
} from '@/entities/giveaway/types';
import DetailedGiveawayActiveInfo from './DetailedGiveawayActiveInfo';
import DetailedGiveawayArchiveInfo from './DetailedGiveawayArchiveInfo';

interface DetailedGiveawayInfoProps {
  giveaway: GiveawayDetailed | GiveawayDetailedArchive;
}

const DetailedGiveawayInfo: FC<DetailedGiveawayInfoProps> = ({ giveaway }) => {
  return (
    <>
      {giveaway.status === 'active' ? (
        <DetailedGiveawayActiveInfo giveaway={giveaway as GiveawayDetailed} />
      ) : (
        <DetailedGiveawayArchiveInfo
          giveaway={giveaway as GiveawayDetailedArchive}
        />
      )}
    </>
  );
};

export default DetailedGiveawayInfo;
